import { Addon } from "../../api/grpc/subscription/subscription";

const UNLIMITED_USER_ADDON_PRICE_IDS = new Set([
  "User-Unlimited-1-Year-USD-Yearly",
  "User-Unlimited-1-Year-GBP-Yearly",
  "User-Unlimited-1-Year-EUR-Yearly",
  "User-Unlimited-1-Year-SEK-Yearly",
  "User-Unlimited-3-Year-USD-Every-3-years",
  "User-Unlimited-3-Year-GBP-Every-3-years",
  "User-Unlimited-3-Year-EUR-Every-3-years",
  "User-Unlimited-3-Year-SEK-Every-3-years",
]);

export const hasUnlimitedUsersAddon = (addons: Addon[]): boolean =>
  addons.some((addon) =>
    UNLIMITED_USER_ADDON_PRICE_IDS.has(addon.itemPriceId)
  );
